/** The whole lower 48, used until there is anything to fit to. */
export const US_CENTER: [number, number] = [39.5, -96];
export const US_ZOOM = 4;

/** Pin colours. Two kinds of place, two hues — customer locations vs warehouses. */
export const CUSTOMER_TONE = '#3b82f6';
export const WAREHOUSE_TONE = '#0f172a';

/** `[[south, west], [north, east]]`, or null when there is nothing to frame. */
export function boundsOf(
  points: { latitude: number; longitude: number }[]
): [[number, number], [number, number]] | null {
  if (points.length === 0) return null;

  const lats = points.map((p) => p.latitude);
  const lngs = points.map((p) => p.longitude);

  return [
    [Math.min(...lats), Math.min(...lngs)],
    [Math.max(...lats), Math.max(...lngs)],
  ];
}

/** "Hartford, CT" — the label the office reads first. */
export const locationLabel = (location: {
  city: string | null;
  state: string | null;
  line1: string | null;
}): string =>
  [location.city, location.state].filter(Boolean).join(', ') ||
  location.line1 ||
  'Unknown location';

/** Pin radius grows with how many customers share the address (clamped). */
export const customerPinRadius = (occupantCount: number): number =>
  Math.min(9 + Math.max(0, occupantCount - 1) * 1.5, 18);

/** The street line for a pin popup, e.g. "12 Quarry Rd, Monroe, CT 06468". */
export const formatAddressLine = (location: {
  line1: string | null;
  city: string | null;
  state: string | null;
  postalCode?: string | null;
}): string =>
  [location.line1, [location.city, location.state].filter(Boolean).join(', '), location.postalCode]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' · ');
